import { ModelName, usePermission, UsePermissionArgs } from "@tellescope/tanstack-query";
import { ReactNode } from "react";

export interface PermissionWrapperProps<Model extends ModelName> extends UsePermissionArgs<Model> {
  children: ReactNode;
}

export const PermissionWrapper = <Model extends ModelName>({
  children,
  ...hookArgs
}: PermissionWrapperProps<Model>) => {
  const { access } = usePermission(hookArgs);

  if (access === false) {
    return null;
  }

  return children;
};
